<template>
  <div :id="`${source}_sequence_analytics`" class="flex flex-col gap-4">
    <AnalyticsFilterComponent :allowed-filters="sequenceAllowedFilters" />

    <div class="flex flex-col gap-8 mb-3">
      <SequenceAnalyticsGrid />

      <div
        v-for="(component, index) in visibleComponents"
        :key="`${component.id}_component_${index}`"
        class="flex flex-col gap-3"
      >
        <span class="text-lg font-semibold">{{ component.text }}</span>
        <component
          :is="component.component"
          :source="source"
          :activity-type="component.id"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { sequenceAllowedFilters } from "@/src/constants/analyticConstants.js";
import AnalyticsFilterComponent from "@/src/views/analytics/v2/AnalyticsFilterComponent.vue";
import SequenceAnalyticsGrid from "@/src/views/analytics/v2/sequence_analytics/SequenceAnalyticsGrid.vue";
import SequenceTasksAnalytics from "@/src/views/analytics/v2/sequence_analytics/tasks/SequenceTasksAnalytics.vue";
import SequenceEmailAnalytics from "@/src/views/analytics/v2/sequence_analytics/email/SequenceEmailAnalytics.vue";
import SequenceLinkedinAnalytics from "@/src/views/analytics/v2/sequence_analytics/linkedin/SequenceLinkedinAnalytics.vue";

const props = defineProps({
  source: { type: String, required: true },
});

const isLinkedinEnabled = localStorage.getItem("linkedin_blocks") === "true"; 

const components = ref([
  {
    id: "email_activity_analytics",
    text: "Email",
    component: SequenceEmailAnalytics,
    show: true,
  },
  {
    id: "linkedin_activity_analytics",
    text: "LinkedIn",
    component: SequenceLinkedinAnalytics,
    show: isLinkedinEnabled,
  },
  {
    id: "tasks_activity_analytics",
    text: "Tasks",
    component: SequenceTasksAnalytics,
    show: true,
  },
]);

const visibleComponents = computed(() =>
  components.value.filter((component) => component.show),
);
</script>
